import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from 'react-router-dom';
import * as Yup from "yup";
import {TranslateContext} from "../../context/TranslateContext";
import {aggiornaFrequenzaApi, aggiungiFrequenzaApi, getFrequenzaByIdApi} from "./services/FrequenzeServices";
import ModificaFrequenzaView from "./ModificaFrequenzaView";

export default function ModificaFrequenzaController() {
    const {id} = useParams()

    const [loadingData, setLoadingData] = useState(true);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {translate} = useContext(TranslateContext);

    const history = useHistory();
    const formikRef = useRef();

    async function getFrequenza() {
        const response = await getFrequenzaByIdApi(id);
        setLoadingData(false);

        if (formikRef.current) {
            formikRef.current.setFieldValue("id_frequenza_compilazione", response.data.data.id_frequenza_compilazione);
            formikRef.current.setFieldValue("codice", response.data.data.codice);
            formikRef.current.setFieldValue("descrizione", response.data.data.descrizione);
            formikRef.current.setFieldValue("canc", response.data.data.canc);
        }
    }

    useEffect(() => {
        if (loadingData) {
            if (id && id !== '') {
                getFrequenza();
            }
        }
    }, []);

    const SignupSchema = Yup.object().shape({
        codice: Yup.string()
            .max(20, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio')),
        descrizione: Yup.string()
            .max(200, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio')),
    });

    async function aggiornaFrequenza(values) {
        const response = await aggiornaFrequenzaApi(id, values);
        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function aggiungiFrequenza(values) {
        const response = await aggiungiFrequenzaApi(values);
        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    const bottoniSx = [
        {
            icon: 'fas fa-angle-left',
            command: () => {
                history.goBack();
            }
        }
    ];

    const bottoniDx = [
        {
            label: translate("Salva"),
            icon: "fas fa-save",
            command: () => {
                if (formikRef.current) {
                    formikRef.current.handleSubmit()
                }
            }
        }
    ];

    const initialFormValues = {
        id_frequenza_compilazione: '',
        codice: '',
        descrizione: '',
        canc: ''
    };

    function onSubmitForm(values) {
        if (id) {
            aggiornaFrequenza(values);
        } else {
            aggiungiFrequenza(values);
        }
    }

    return (
        <ModificaFrequenzaView
            setShow={setShow}
            formikRef={formikRef}
            show={show}
            modalMsg={modalMsg}
            id={id}
            SignupSchema={SignupSchema}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
            initialFormValues={initialFormValues}
            onSubmitForm={onSubmitForm}
        />
    );
}